'use client';

import React, { useRef } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GOLD = '#D48937';

export default function LegalPage({ eyebrow = 'Rechtliches', title, updated, children }) {
    const containerRef = useRef(null);

    useGSAP(
        () => {
            const mm = gsap.matchMedia();
            mm.add('(prefers-reduced-motion: no-preference)', () => {
                const tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
                tl.from('[data-legal-eyebrow]', { autoAlpha: 0, y: 12, duration: 1 }, 0)
                  .from('[data-legal-title]', { autoAlpha: 0, x: -32, duration: 1.4 }, 0.1)
                  .from('[data-legal-rule]', { scaleX: 0, transformOrigin: 'left center', duration: 1.2 }, 0.3)
                  .from('[data-legal-body]', { autoAlpha: 0, y: 24, duration: 1.2 }, 0.45);
            });
        },
        { scope: containerRef }
    );

    return (
        <>
            <div
                ref={containerRef}
                className="relative z-20 min-h-screen bg-gradient-to-br from-white to-gray-200 text-neutral-800"
            >
                <Navbar />

                <main className="px-6 pb-32 pt-28 md:px-12 md:pt-24 lg:px-20">
                    <div className="mx-auto max-w-3xl">
                        <header className="mb-14 md:mb-20">
                            {eyebrow && (
                                <p
                                    data-legal-eyebrow
                                    className="mb-3 text-[10px] uppercase tracking-[0.35em]"
                                    style={{ color: GOLD }}
                                >
                                    {eyebrow}
                                </p>
                            )}
                            <h1
                                data-legal-title
                                className="font-pp-neue text-[clamp(2.25rem,5vw,4rem)] font-normal leading-none tracking-tight text-neutral-900"
                            >
                                {title}
                            </h1>
                            <div
                                data-legal-rule
                                className="mt-5 h-px w-full"
                                style={{ background: `linear-gradient(to right, ${GOLD}, transparent)` }}
                            />
                        </header>

                        <div data-legal-body className="legal-prose">
                            {children}
                            {updated && (
                                <p className="mt-12 text-xs text-neutral-400">Stand: {updated}</p>
                            )}
                        </div>
                    </div>
                </main>
            </div>

            <Footer />
        </>
    );
}
